import { render, staticRenderFns } from "./Compose.vue?vue&type=template&id=45edee07"
import script from "./Compose.vue?vue&type=script&lang=js"
export * from "./Compose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45edee07')) {
      api.createRecord('45edee07', component.options)
    } else {
      api.reload('45edee07', component.options)
    }
    module.hot.accept("./Compose.vue?vue&type=template&id=45edee07", function () {
      api.rerender('45edee07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messaging/Compose.vue"
export default component.exports